import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div style={{
                display: 'flex',
                gap: '2rem',
                justifyContent: 'center',
                marginBottom: '1rem',
                flexWrap: 'wrap'
            }}>
                <Link
                    to="/impressum"
                    style={{
                        color: '#596678',
                        textDecoration: 'none',
                        transition: 'color 0.3s ease',
                        fontSize: '0.95rem'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#007AFF'}
                    onMouseLeave={(e) => e.target.style.color = '#596678'}
                >
                    Impressum
                </Link>
                <Link
                    to="/datenschutz"
                    style={{
                        color: '#596678',
                        textDecoration: 'none',
                        transition: 'color 0.3s ease',
                        fontSize: '0.95rem'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#007AFF'}
                    onMouseLeave={(e) => e.target.style.color = '#596678'}
                >
                    Datenschutz
                </Link>
            </div>
            <p className="footer-text">
                © 2025 VolleyScout • Entwickelt mit ❤️ für Volleyball-Trainer
            </p>
        </footer>
    );
};

export default Footer;